export const rndData = {
  banner: {
    image: "/images/pro-banner-1.jpg",
    alt: "Research and Development",
  },
  breadcrumb: [
    { label: "HOME", href: "/" },
    { label: "R & D", href: "/rnd" },
  ],
  pageTitle: "Research and Development",
  intro: {
    title: "Research and Development",
    htmlIntro:
      "Our R&D centre located at Mumbai  provides process research for API intermediates.<br/>Our team of researchers have developed several novel processes for producing intermediates of well-known API's. Other activities include analytical process development and IP analysis.",
    image: "/images/rnd-img.jpg",
    imageAlt: "Research & Development",
  },
  majorActivities: {
    title: "Major Activities:",
    items: [
      "Route screening",
      "Process Development",
      "Scale up",
      "Technology Transfer",
      "Synthesizing Impurities",
      "Contract Research",
    ],
  },
  analyticalDevelopment: {
    title: "Analytical Development",
    description:
      "We have a dedicated analytical development laboratory to support the synthesis group.",
    subTitle: "Major activities:",
    items: [
      "Analytical method development & validation, for RM, WIP & Finished Products",
      "OVI method development & Method validation",
      "Impurity profile studies",
    ],
  },
};
